import { createSlice } from "@reduxjs/toolkit";
import { languages } from "../Language";

const initialState = {
  ...languages.en,
  report: "Report",
  reports: "Reports",
};

export const languageSlice = createSlice({
  name: "language",
  initialState: initialState,
  reducers: {
    selectLanguage: (state, action) => {
      const langCode = action?.payload?.lang === "bn" ? "bn" : "en";
      const baseDict = languages[langCode] || languages.en;
      return {
        ...baseDict,
        ...(action.payload || {}),
        report: langCode === "bn" ? "রিপোর্ট" : "Report",
        reports: langCode === "bn" ? "রিপোর্ট" : "Reports",
      };
    },
    resetLanguage: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase("persist/REHYDRATE", (state, action) => {
      const persistedLang =
        action?.payload?.languageReducer ||
        (action?.payload?.lang ? action.payload : null);
      if (persistedLang) {
        const langCode = persistedLang?.lang === "bn" ? "bn" : "en";
        const baseDict = languages[langCode] || languages.en;
        const merged = { ...baseDict, ...persistedLang };
        for (const key of Object.keys(baseDict)) {
          if (!merged[key]) {
            merged[key] = baseDict[key];
          }
        }
        if (!merged.report) merged.report = langCode === "bn" ? "রিপোর্ট" : "Report";
        if (!merged.reports) merged.reports = langCode === "bn" ? "রিপোর্ট" : "Reports";
        return merged;
      }
      return state;
    });
  },
});

export const { selectLanguage, resetLanguage } = languageSlice.actions;
export const languageReducer = languageSlice.reducer;

